module.exports = __webpack_public_path__ + "img/ma268.280ae23f.png";